<template>
  <div class="space">
    <div class="base-search">
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px">标的名称:</label>
      <el-input
        placeholder="请输入标的名称"
        v-model="paramsObj.achievementName"
        class="input-with-select"
        @keyup.enter.native="getData"
        clearable
        @clear="getData"
        style="width:240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
      </el-input>
      <!-- <label style="margin-right: 10px; line-height: 40px; min-width: 60px">
        企业/团队名称:
      </label>
      <el-input
        placeholder="请输入企业/团队名称"
        v-model="paramsObj.name"
        class="input-with-select"
        clearable
        @clear="getData"
      >
        <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
      </el-input> -->
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px">审核状态:</label>
      <el-select
        v-model="paramsObj.approvalStatus"
        placeholder="请选择审核状态"
        clearable
        @change="getData"
      >
        <el-option label="待审核" :value="1" />
        <el-option label="驳回" :value="2" />
        <el-option label="通过" :value="4" />
      </el-select>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
      >
        <el-table-column type="index" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="unit" label="企业/团队名称" align="center"></el-table-column> -->
        <el-table-column prop="applicantName" label="申请人" align="center"></el-table-column>
        <el-table-column prop="contact" label="联系方式" align="center"></el-table-column>
        <el-table-column prop="achievementName" label="标的名称" align="center"></el-table-column>
        <el-table-column
          prop="startingPrice"
          label="起拍价格（元）"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="evaluationPrice"
          label="评估价格（元）"
          align="center"
        ></el-table-column>
        <el-table-column prop="markup" label="加价幅度(元)" align="center"></el-table-column>
        <el-table-column prop="approvalStatus" label="审核状态" align="center">
          <template slot-scope="scope">
            {{
              scope.row.approvalStatus === 1
                ? '待审核'
                : scope.row.approvalStatus === 4
                ? '通过'
                : '驳回'
            }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" prop="createTime"></el-table-column>
        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.auctionStatus === 1">已取消</span>
            <el-button v-else class="mini_btn" type="text" @click="handleEdit(scope.row, false)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="paramsObj.page"
      :page-size="paramsObj.pageSize"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>
    <el-dialog
      title="审核拍卖信息"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
        class="demo-formData"
      >
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起拍价格" prop="startingPrice">
                <el-input
                  type="number"
                  v-model="formData.startingPrice"
                  :disabled="abutmentStatus !== 1"
                  placeholder="卖家填写的起拍价格"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="评估价格" prop="evaluationPrice">
                <el-input
                  type="number"
                  v-model="formData.evaluationPrice"
                  :disabled="abutmentStatus !== 1"
                  placeholder="请输入评估价格"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="加价幅度(元)" prop="markup">
                <el-input
                  type="number"
                  v-model="formData.markup"
                  :disabled="abutmentStatus !== 1"
                  placeholder="卖家填写的加价幅度(元)"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="审核状态" prop="approvalStatus">
                <el-select
                  v-model="formData.approvalStatus"
                  placeholder="请选择审核状态"
                  :disabled="abutmentStatus !== 1"
                  clearable
                  style="width: 100%;"
                >
                  <el-option label="待审核" :value="1" />
                  <el-option label="驳回" :value="2" />
                  <el-option label="通过" :value="4" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="审核意见"
                :disabled="abutmentStatus !== 1"
                prop="approvalComments"
              >
                <el-input
                  v-model="formData.approvalComments"
                  placeholder="请填写审核意见"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件上传" prop="attachment">
                <el-upload
                  class="upload-demo"
                  :action="this.uploadURL"
                  style="text-align: left;"
                  :disabled="abutmentStatus !== 1"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, 'fileList')"
                  :file-list="fileList"
                  :on-success="
                    (response, file, fileList) =>
                      handleAvatarSuccess(response, file, fileList, 'fileList')
                  "
                  list-type="picture"
                >
                  <el-button size="small" type="primary" :disabled="fileList.length === 1">
                    上传附件材料
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="form-title">基本信息</div>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="成果名称" prop="name">
                <el-input
                  v-model="formData.name"
                  placeholder="请输入成果名称"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="所属领域" prop="field">
                <el-select
                  multiple
                  v-model="formData.field"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in checkList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="应用行业" prop="trade">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="formData.trade"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="成熟度" prop="mastery">
                <el-select
                  multiple
                  v-model="formData.mastery"
                  placeholder="请选择"
                  style="width:100%"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in options.stage"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="合作方式" prop="way">
                <el-select
                  multiple
                  v-model="formData.way"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in options.cooperation"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item style="text-align: right" label="封面图片" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
                disabled
              >
                <img v-if="formData.logo" :src="imgUrl + formData.logo" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !formData.logo }"
                ></i>
                <span class="upload_btn" v-if="!formData.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术先进度" prop="advanced">
              <el-select
                v-model="formData.advanced"
                placeholder="请选择"
                style="width: 100%"
                clearable
                disabled
              >
                <el-option
                  v-for="(item, index) in options.stage1"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="pubdate">
              <el-date-picker
                style="width: 100%"
                v-model="formData.pubdate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="pickerOptions"
                disabled
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="行业分类" prop="levelId">
            <el-cascader
              v-model="formData.levelId"
              placeholder="请选择"
              :options="sortOptions"
              style="width: 100%"
              clearable
              disabled
              :props="{ value: 'id', label: 'name' }"
            ></el-cascader>
          </el-form-item>
        </el-row>
        <div class="form-title">项目来源</div>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="个人/单位">
                <el-select style="width:100%" v-model="formData.isPerson" disabled>
                  <el-option :value="1" label="个人"></el-option>
                  <el-option :value="2" label="单位"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="people">
                <el-input
                  disabled
                  v-model="formData.people"
                  placeholder="请输入联系人"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input
                  v-model="formData.phone"
                  placeholder="请输入联系电话"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="通信地址" prop="detailed">
              <v-distpicker
                style="text-align: left"
                @selected="citySelected"
                :province="formData.address.province.value"
                :city="formData.address.city.value"
                :area="formData.address.area.value"
                disabled
              ></v-distpicker>
              <el-input
                style="margin-top: 10px"
                v-model="formData.detailed"
                placeholder="请填写详细地址"
                disabled
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row v-if="formData.isPerson == 2">
            <el-col :span="12">
              <el-form-item label="单位名称" prop="unit">
                <el-input
                  v-model="formData.unit"
                  placeholder="请输入单位名称"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位性质" prop="unit_properties">
                <el-select
                  v-model="formData.unit_properties"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in options.source1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="formData.isPerson == 2">
            <el-col :span="12">
              <el-form-item label="成果来源" prop="natural_json">
                <el-cascader
                  disabled
                  placeholder="请选择"
                  style="width: 100%"
                  v-model="formData.natural_json"
                  :options="options.source"
                  :props="{ value: 'id', label: 'name', children: 'sub' }"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="form-title">项目简介</div>
        <el-row>
          <el-form-item label="成果简介" prop="introduction">
            <editor
              v-if="dialogFormVisible"
              v-model="formData.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
              disabled
            ></editor>
          </el-form-item>
        </el-row>
        <el-form-item style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="subData()">提交</el-button>
          <el-button @click="closeForm('formData')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import _ from 'lodash-es'
// import editor from '../../../components/tinymce-editor/tinymce-editor';
import editor from '../../../components/tinymce-editor/tinymce-editor';
export default {
	components: {
    editor
	},
	data() {
		return {
      is_Submit:false,
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      paramsObj:{
        achievementName:"",
        // name:"",
        approvalStatus:"",
        page: 1,
        pageSize: 10,
        address: null
      },
			total: 0,
			dialogFormVisible: false,
			tableData: [],
      formData:{
        address: {
          //通信地址
          province: {
            value: '甘肃省',
          },
          city: {
            value: '兰州市',
          },
          area: {
            value: '城关区',
          },
        }
      },
      fileList:[],
      rules:{},
      checkList: [
        {
          id: '001',
          name: '新能源',
        },
        // {
        //   id: '002',
        //   name: '清洁生产',
        // },
        // {
        //   id: '003',
        //   name: '清洁能源',
        // },
        {
          id: '004',
          name: '现代农业',
        },
        {
          id: '005',
          name: '生物医药',
        },
        {
          id: '006',
          name: '文化旅游',
        },
        {
          id: '007',
          name: '通道物流',
        },
        {
          id: '008',
          name: '军民融合',
        },
        {
          id: '009',
          name: '数据信息',
        },
        {
          id: '010',
          name: '装备制造',
        },
        {
          id: '011',
          name: '新材料',
        },
        // {
        //   id: "011",
        //   name: "文化旅游"
        // },
        // {
        //   id: "012",
        //   name: "通道物流"
        // },
      ],
      typeOptions: [
        {
          value: '001',
          label: '农业与化工',
        },
        {
          value: '002',
          label: '生物与医药',
        },
        {
          value: '003',
          label: '能源与采矿',
        },
        {
          value: '004',
          label: '建筑与水利',
        },
        {
          value: '005',
          label: '交通与运输',
        },
        {
          value: '006',
          label: '自然与社科',
        },
      ],
      sortOptions: [],
      options:{
        stage: [
          {
            value: '001',
            label: '正在研发',
          },
          {
            value: '002',
            label: '已有样品',
          },
          {
            value: '003',
            label: '小试阶段',
          },
          {
            value: '004',
            label: '中试阶段',
          },
          {
            value: '005',
            label: '可以量产',
          },
        ],
        cooperation: [
          {
            value: '001',
            label: '委托开发',
          },
          {
            value: '002',
            label: '许可转让',
          },
          // {
          //   value: "003",
          //   label: "完全转让",
          // },
          {
            value: '008',
            label: '非专利转让',
          },
          {
            value: '009',
            label: '专利权转让',
          },
          {
            value: '010',
            label: '专利申请权转让',
          },
          {
            value: '011',
            label: '专利实施许可转让',
          },
          {
            value: '004',
            label: '技术入股',
          },
          {
            value: '005',
            label: '技术许可',
          },
          {
            value: '006',
            label: '合作转化',
          },
          // {
          //   value: "007",
          //   label: "自我转化"
          // },
          {
            value: '007',
            label: '其他',
          },
        ],
        stage1: [
          {
            value: '001',
            label: '国际领先',
          },
          {
            value: '002',
            label: '国际先进',
          },
          {
            value: '003',
            label: '国内领先',
          },
          {
            value: '004',
            label: '国内先进',
          },
          // {
          //   value: "005",
          //   label: "国内一般"
          // }
        ],
        source1: [
          {
            value: '001',
            label: '民营企业',
          },
          {
            value: '002',
            label: '国有企业',
          },
          {
            value: '003',
            label: '其他',
          },
        ],
        abutmentStatus:0,
        source: [
          {
            value: '001',
            label: '技术转移中心',
            children: [
              {
                value: '0011',
                label: '张江兰白创新改革试验区技术转移中心',
              },
              {
                value: '0012',
                label: '北京大学技术转移甘肃中心',
              },
              {
                value: '0013',
                label: '中国科学技术大学技术转移甘肃中心',
              },
              {
                value: '0014',
                label: '国家技术转移东部中心',
              },
              {
                value: '0015',
                label: '瑞士洛桑大学技术转移中心',
              },
              {
                value: '0016',
                label: '新加坡南洋理工大学技术转移中心',
              },
            ],
          },
          {
            value: '002',
            label: '一院三所',
            children: [
              {
                value: '0021',
                label: '中国科学院兰州化学物理研究所',
              },
              {
                value: '0022',
                label: '中国科学院近代物理研究所',
              },
              {
                value: '0023',
                label: '中国科学院寒区旱区环境与工程研究所',
              },
            ],
          },
          {
            value: '003',
            label: '在甘院校',
            children: [
              {
                value: '0031',
                label: '高等院校',
                children: [
                  {
                    value: '00311',
                    label: '兰州大学',
                  },
                  {
                    value: '00312',
                    label: '兰州理工大学',
                  },
                  {
                    value: '00313',
                    label: '兰州交通大学',
                  },
                  {
                    value: '00314',
                    label: '西北民族大学',
                  },
                  {
                    value: '00315',
                    label: '甘肃农业大学',
                  },
                  {
                    value: '00316',
                    label: '兰州城市学院',
                  },
                  {
                    value: '00317',
                    label: '西北师范大学',
                  },
                  {
                    value: '00318',
                    label: '河西学院',
                  },
                  {
                    value: '00319',
                    label: '陇东学院',
                  },
                ],
              },
              {
                value: '0032',
                label: '科研院所',
                children: [
                  {
                    value: '00321',
                    label: '甘肃省科学院',
                  },
                  {
                    value: '00322',
                    label: '甘肃省农业科学院',
                  },
                  {
                    value: '00323',
                    label: '甘肃省膜科学技术研究院有限公司',
                  },
                  {
                    value: '00324',
                    label: '甘肃省科学院生物研究所',
                  },
                  {
                    value: '00325',
                    label: '甘肃省商业科技研究所',
                  },
                  {
                    value: '00326',
                    label: '甘肃省建材科研设计院',
                  },
                ],
              },
            ],
          },
          {
            value: '004',
            label: '省属企业',
          },
          {
            value: '005',
            label: '省外合作机构',
          },
          {
            value: '006',
            label: '新型研发机构',
            children: [
              {
                value: '0061',
                label: '兰州大学白银产业技术研究院',
              },
              {
                value: '0062',
                label: '兰州理工大学白银新材料研究院',
              },
              {
                value: '0063',
                label: '甘肃西部凹凸棒石应用研究院',
              },
              {
                value: '0064',
                label: '白银市东西部协同创新研究院',
              },
              {
                value: '0065',
                label: '甘肃省陇杞中药研究院',
              },
              {
                value: '0066',
                label: '白银市实创高新产业研究院',
              },
            ],
          },
          {
            value: '007',
            label: '其他',
          },
        ],
      }
		};
	},
	created() {
    const userInfo = JSON.parse(this.$store.getters.userInfo);
    if (userInfo.role_id === 29) {
      this.paramsObj.address = '金昌市';
    }
    this.getData();
    this.getTrees();
	},
	methods: {
    //行业分类
    getTrees() {
      this.http.get('/trade/tree').then(res => {
        if (res.code == 0) {
          this.sortOptions = res.data;
        }
      });
    },
    // 禁用今日以后时间
    disabledDateFn(date) {
      let flag = DisabledDateFn(date);
      return flag;
    },
    getData() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/achievement-auction/page`, this.paramsObj).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
		//城市选择
		citySelected(e) {
			this.formData.address = e;
		},
    handleRemove(file, fileList, type) {
      this.fileList = fileList;
      if (fileList.length === 0) {
        this.formData.attachment = '';
      } else {
        this.formData.attachment = JSON.stringify(fileList);
      }
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        console.log(fileList);
        var obj = file
        obj.url=urlConfig.imgUrl+file.response.data.store_result
        this.fileList.push(obj)
        // this.fileList = fileList;
        if (fileList.length === 0) {
          this.formData.attachment = '';
        } else {
          this.formData.attachment = JSON.stringify(fileList);
        }
      }
    },
    handlePictureCardPreview(file) {
      this.formData.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      if(this.fileList.length >0) return false
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      // var img = new Image();
      // img.src = this.image;
      // img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, 'HouImg');
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64,
            })
            .then(res => {
              this.formData.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.formData.logo = '';
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
		//编辑
		handleEdit(row, status) {
      this.fileList = []
      this.http
        .get(`${urlConfig.devUrl}apij2/admin-api/trade/achievement-auction/get?id=${row.id}`)
        .then(res => {
          this.formData = res.data;
          this.formData.creatorName = JSON.parse(this.$store.getters.userInfo).name;
          this.abutmentStatus = this.formData.approvalStatus
          if(this.formData.attachment){
          this.fileList = [JSON.parse(this.formData.attachment)[0]]
          // this.fileList = JSON.parse(this.formData.attachment)[0].response.data.store_result
          }
          this.copy();
          this.dialogFormVisible = true;
        });
		},
    copy() {
      if (this.formData.field) {
        this.formData.field = this.formData.field.split(',');
      }
      if (this.formData.trade) {
        this.formData.trade = this.formData.trade.split(',');
      }
      if (this.formData.way) {
        this.formData.way = this.formData.way.split(',');
      }
      if (this.formData.mastery) {
        this.formData.mastery = this.formData.mastery.split(',');
      }
      // if (this.formData.advanced) {
      //   this.formData.advanced = this.formData.advanced.split(',');
      // }
      this.formData.detailed = this.formData.address.detailed;
      this.formData.logo = this.formData.logo;
      this.formData.is_show = 3;
      if (this.formData.natural_json) {
        this.formData.natural_json = JSON.parse(this.formData.natural_json);
      }
      this.formData.levelId = this.formData.levelId || [];
    },
		//翻页
		handleCurrentChange(val) {
      this.paramsObj.page = val;
      this.getData();
		},
		//取消
		closeForm() {
			this.dialogFormVisible = false;
		},
		subData:_.throttle(function(item) {
      if(this.is_Submit)return
      this.is_Submit = true
      this.$refs['formData'].validate(valid => {
        if (valid) {
          this.http
            .post(
              `${urlConfig.devUrl}apij2/admin-api/trade/achievement-auction/approval`,
              this.formData
            )
            .then(res => {
              this.is_Submit = false
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.getData();
                this.dialogFormVisible = false;
                this.$refs['formData'].resetFields();
              } else {
                this.$message.error(res.status);
              }
            }).catch(err =>{
              this.is_Submit = false
            });
        } else {
          this.is_Submit = false
          return false;
        }
      });
		},3000,{ leading: true, trailing: false }),
		//提交
		// submitForm: debounce (
		// 	async function() {
		// 	this.$refs.toFrom.parentHandleclick((valid) => {
		// 		if(valid) {
		// 			this.subData(valid)
		// 		}
		// 	}, 500, {
		// 		leading: true,
    //     trailing: false
		// 	});
		// })
	},
};
</script>

<style scoped lang="scss">
.space {
  height: 100%;
  width: 100%;

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-select {
      margin: 0 15px;
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      width: 300px;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
.avatar-uploader {
  text-align: center;
  width: 243px;
  img {
    max-width: 100%;
  }
}
.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
</style>
